import { render, staticRenderFns } from "./RSSItem.vue?vue&type=template&id=54e726e6&scoped=true&"
import script from "./RSSItem.vue?vue&type=script&lang=js&"
export * from "./RSSItem.vue?vue&type=script&lang=js&"
import style0 from "./RSSItem.vue?vue&type=style&index=0&id=54e726e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e726e6",
  null
  
)

export default component.exports